"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function () {
  var ownKeys = function (o) {
    ownKeys = Object.getOwnPropertyNames || function (o) {
      var ar = [];
      for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
      return ar;
    };
    return ownKeys(o);
  };
  return function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
    __setModuleDefault(result, mod);
    return result;
  };
}();
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DotsRight = exports.DotsLeft = exports.ChevronRight = exports.ChevronLeft = exports.Button = exports.Container = void 0;
const styled_components_1 = __importStar(require("styled-components"));
exports.Container = styled_components_1.default.div`
  display: flex;
`;
exports.Button = styled_components_1.default.button`
  &&& {
    background: 0;
    border: 1px solid #3399cc;
    color: #3399cc;
    font-family: 'Verdana';
    font-weight: 700;
    height: 24px;
    min-width: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    padding: 0;
    cursor: pointer;

    ${props => props.isActive && (0, styled_components_1.css)`
        border-color: #1575a6;
        background-color: #3399cc;
        color: #fff;
        cursor: initial;
      `}

    ${props => props.isDisabled && (0, styled_components_1.css)`
        border-color: #a3a4a4;
        color: #a3a4a4;
        cursor: initial;
      `}

    ${props => !props.isActive && !props.isDisabled && (0, styled_components_1.css)`
        &:hover {
          border-color: #1575a6;
          transition: border-color 0.2s;
        }
      `}
  }

  & + & {
    margin-left: 8px;
  }
`;
const Chevron = styled_components_1.default.div`
  border-color: #3399cc;
  border-left: 2px solid;
  border-top: 2px solid;
  border-radius: 1px;
  height: 6px;
  width: 6px;
`;
exports.ChevronLeft = (0, styled_components_1.default)(Chevron)`
  transform: rotate(-45deg);
  margin-right: -3px;
`;
exports.ChevronRight = (0, styled_components_1.default)(Chevron)`
  transform: rotate(135deg);
  margin-left: -3px;
`;
const Dots = styled_components_1.default.div`
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: center;
  display: flex;
  &:before {
    content: '...';
    vertical-align: middle;
  }
  &:after {
    content: '';
  }

  &:hover {
    &:before {
      content: '';
      border-color: #3399cc;
      border-left: 2px solid;
      border-top: 2px solid;
      border-radius: 1px;
      height: 6px;
      width: 6px;
    }
    &:after {
      border-color: #3399cc;
      border-left: 2px solid;
      border-top: 2px solid;
      border-radius: 1px;
      height: 6px;
      width: 6px;
    }
  }
`;
exports.DotsLeft = (0, styled_components_1.default)(Dots)`
  &:hover {
    &:before {
      transform: rotate(-45deg);
      margin-left: 2px;
    }
    &:after {
      transform: rotate(-45deg);
      margin-left: -2px;
    }
  }
`;
exports.DotsRight = (0, styled_components_1.default)(Dots)`
  &:hover {
    &:before {
      transform: rotate(135deg);
      margin-left: -2px;
    }
    &:after {
      transform: rotate(135deg);
      margin-left: -2px;
    }
  }
`;